import { useTracking } from 'react-tracking';
import { NarrativesRelatedList } from './components/NarrativesRelatedList';
import { Suspense } from 'react';
import { NarrativeCardLoading } from '@/components/NarrativeCard';
import { ErrorBoundary } from '@sentry/react';
import { Alert, AlertAction } from '@simplywallst/ui-core';
import { VISIBLE_NARRATIVES } from './utils';

const PLACEHOLDER_ITEMS = Array.from({ length: VISIBLE_NARRATIVES });

type Props = {
  slug: string;
};

export const NarrativesRelated = ({ slug }: Props) => {
  const { Track } = useTracking({
    type: 'track',
    subject: 'related_narratives',
  });

  return (
    <Track>
      <section className="grid w-full gap-x2 overflow-hidden rounded-x1 bg-surface-1 p-x3">
        <h2 className="m-0 text-sm font-normal text-softer">
          Read more narratives
        </h2>
        <ErrorBoundary
          fallback={
            <Alert
              styleType="negative"
              actions={
                <AlertAction onClick={() => window.location.reload()}>
                  Reload
                </AlertAction>
              }
            >
              Failed to load related narratives. Please try again.
            </Alert>
          }
        >
          <Suspense
            fallback={
              <section
                className="grid grid-cols-[repeat(4,317px)] gap-x1"
                role="presentation"
                aria-label="Loading skeleton"
              >
                {PLACEHOLDER_ITEMS.map((_, index) => (
                  <NarrativeCardLoading showCompanyIcon key={index} />
                ))}
              </section>
            }
          >
            <NarrativesRelatedList slug={slug} />
          </Suspense>
        </ErrorBoundary>
      </section>
    </Track>
  );
};
